module.exports = __webpack_public_path__ + "static/media/2023-Sub-Exclusive-Feature-Banner-sm@2x.5201fbdf.jpg";